var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"text-align":"center","font-size":"24px","margin-top":"50px"}},[_vm._v("这不是你该看的......")])])
}]

export { render, staticRenderFns }